export default __webpack_public_path__ + "static/media/bedroom2.a60df60a.webp";